/* sm-announcement-bar — seamless marquee: clone the message group until the track is >= 3x the viewport
   (min 4 copies), then animate exactly one group-width so the loop has no seam. Mirrors Manukora's
   AnnouncementBarInfiniteScroll. Re-runs on resize. */
(function () {
  function init(bar) {
    var track = bar.querySelector('[data-sm-ab-track]');
    if (!track) return;
    var group = track.querySelector('.sm-announcement-bar__group');
    if (!group) return;
    var id = (bar.id || 'sm-ab').replace(/[^a-zA-Z0-9_-]/g, '');
    var styleTag = null;

    function build() {
      track.innerHTML = '';
      track.appendChild(group);
      var groupWidth = group.offsetWidth;
      if (!groupWidth) return; // hidden — nothing to clone
      var copies = Math.max(Math.ceil((window.innerWidth * 3) / groupWidth), 4);
      for (var i = 1; i < copies; i++) {
        var clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
      if (!styleTag) {
        styleTag = document.createElement('style');
        styleTag.id = 'sm-ab-anim-' + id;
        document.head.appendChild(styleTag);
      }
      styleTag.textContent =
        '@keyframes sm-ab-scroll-' + id + '{0%{transform:translateX(0)}100%{transform:translateX(-' + (100 / copies) + '%)}}';
      track.style.animationName = 'sm-ab-scroll-' + id;
    }

    build();
    var timer = null;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(build, 250);
    });
  }

  function boot() {
    document.querySelectorAll('[data-sm-announcement-bar]').forEach(function (bar) {
      if (bar.dataset.smAbInit) return;
      bar.dataset.smAbInit = '1';
      init(bar);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
